import { render, staticRenderFns } from "./preview_pc.vue?vue&type=template&id=3db894f7&"
import script from "./preview_pc.vue?vue&type=script&lang=js&"
export * from "./preview_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports